import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthServiceService } from './auth-service.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationGuard implements CanActivate {

  // Constructor to inject AuthServiceService and Router
  constructor(private authService: AuthServiceService, private router: Router) {}

  /**
   * Determines if a route can be activated based on the user's authentication status.
   * 
   * @param route - The route being accessed.
   * @param state - The current router state.
   * @returns An observable, promise, or boolean indicating if the route can be activated.
   */
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    // Use the isAuthenticated observable from AuthServiceService to check authentication status
    return this.authService.isAuthenticated.pipe(
      map(isAuthenticated => {
        if (isAuthenticated) {
          // If the user is authenticated, allow route activation
          return true;
        } else {
          // If the user is not authenticated, navigate to the root route and pass the attempted URL as a query parameter
          this.router.navigate([''], { queryParams: { returnUrl: state.url } });
          // Prevent route activation
          return false;
        }
      })
    );
  }
}